<template>
  <Loading v-if="loading" />
  <div class="report">
    <FormKit
      id="report-form"
      v-model="formData"
      type="form"
      :actions="false"
      @submit="submitHandler"
    >
      <ShowSettings
        :value="formData.show"
        :selected-position="formData.position"
        @update:selected-position="updateSelectedPosition"
        @select-option="selectShowSettings"
      />

      <TitleOptions :title="$t('titleUpperCase')" />
      <div class="report__translations">
        <FormKit type="group" name="title_text">
          <div
            v-for="(translation, index) in translations"
            :key="index"
            class="container"
          >
            <span>{{ translation.label }}</span>
            <Input
              type="text"
              :name="translation.value"
              :value="formData.title_text[translation.value]"
            />
          </div>
        </FormKit>
      </div>

      <TitleOptions :title="$t('hintTextUpperCase')" />
      <div class="report__translations">
        <FormKit type="group" name="hint_text">
          <div
            v-for="(translation, index) in translations"
            :key="index"
            class="container"
          >
            <span>{{ translation.label }}</span>
            <Input
              type="text"
              :name="translation.value"
              :value="formData.hint_text[translation.value]"
            />
          </div>
        </FormKit>
      </div>
    </FormKit>
    <Button variant="filled" :title="$t('save')" @click="submitForm" />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapActions, mapState } from 'vuex';

import Loading from '@/views/Loading.vue';

import { translations } from '../configs';
import { OptionsScreen } from '@/store/modules/pharmacy/types';
import { mapScreensToSelectedPositions } from '@/components/UI/ShowSettings/configs';

@Options({
  name: 'Report',
  components: {
    Loading
  },
  data() {
    return {
      loading: false,
      formData: {
        title_text: {
          fi: '',
          sv: '',
          en: ''
        },
        hint_text: {
          fi: '',
          sv: '',
          en: ''
        },
        show: false,
        position: 1
      },
      payload: {},
      positionNotSelected: false,
      translations
    };
  },
  computed: {
    ...mapState('pharmacy', ['pharmacy'])
  },
  created() {
    this.show();
  },
  methods: {
    ...mapActions('pharmacy', ['getPharmacy', 'updateFeedbackTemplate']),
    async show() {
      this.loading = true;

      const { id } = this.$route.params;
      await this.getPharmacy(id);

      this.formData = {
        ...this.pharmacy.feedbackTemplate.report_screen
      };

      this.loading = false;
    },
    updateSelectedPosition(position: number) {
      this.formData.position = position;
    },
    selectShowSettings() {
      this.showSettings = !this.showSettings;
    },
    cleanForm() {
      this.$formkit.reset('report-form');
    },
    submitForm() {
      this.$formkit.submit('report-form');
    },
    async submitHandler(data: OptionsScreen) {
      if (this.positionNotSelected) {
        this.payload = {
          report_screen: {
            ...data
          }
        };
      } else {
        if (this.pharmacy) {
          const screens = this.pharmacy.feedbackTemplate;
          const name = this.$route.name.toLowerCase();

          const selectedPositions = mapScreensToSelectedPositions(
            screens,
            name
          );

          this.payload = {
            report_screen: {
              ...data,
              position: selectedPositions.value
            }
          };
        }
      }

      this.loading = true;

      const { id } = this.$route.params;
      await this.updateFeedbackTemplate({ data: this.payload, pharmacyId: id });
      this.loading = false;
    }
  },
  watch: {
    pharmacy() {
      if (this.pharmacy) {
        this.formData = {
          ...this.pharmacy.feedbackTemplate.report_screen
        };
      }
    }
  }
})
export default class Report extends Vue {}
</script>

<style lang="scss" scoped>
.report {
  padding: 24px;
  #report-form {
    margin-bottom: 32px;
    .report__translations {
      width: 450px;
      .container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 30px;
        &:last-child {
          margin-bottom: 0;
        }
        .input {
          display: inline-block;
          width: 350px;
          margin-left: 15px;
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
